import { useContext, useId } from 'react'

import { FileContext } from './context'
import type { FileProps } from './file'

export type UseFileProviderProps = FileProps

export interface UseFileProviderReturn {
  id: string
  selected: boolean
  disabled: boolean
  error: boolean
  loading: boolean
}

export function useFileProvider(props: UseFileProviderProps): UseFileProviderReturn {
  const { id: idProp, error = false } = props

  const uuid = useId()
  const id = idProp ?? uuid
  const loading = !error && !!props.loading
  const disabled = !error && !!props.disabled
  const selected = !error && !!props.selected

  return {
    id,
    selected,
    disabled,
    error,
    loading,
  }
}

export function useFile() {
  const context = useContext(FileContext)
  return context
}
